__webpack_require__.p = Array.prototype.slice.call(document.getElementsByClassName("js-configuration")).reduce(function(path, el){
      try{
        path = JSON.parse(el.text).dependenciesBaseURL || path;
      }catch(error){
        console.error(error);
      }
      return path;
    }, __webpack_require__.p);